'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isConstrained = isConstrained;
exports.constrain = constrain;
exports.constrainHardOnly = constrainHardOnly;
function isConstrained(value, config) {
  return !!config && (typeof config.min === 'number' && value < config.min || typeof config.max === 'number' && value > config.max);
}

function constrainBounce(value, min, max) {
  var constrainedValue = value;
  if (typeof min === 'number' && constrainedValue < min) {
    constrainedValue = min - Math.pow(Math.abs(constrainedValue - min), 0.85);
  }
  if (typeof max === 'number' && constrainedValue > max) {
    constrainedValue = max + Math.pow(Math.abs(constrainedValue - max), 0.85);
  }
  return constrainedValue;
}

function constrainHard(value, min, max) {
  var constrainedValue = value;
  if (typeof min === 'number') {
    constrainedValue = Math.max(constrainedValue, min);
  }
  if (typeof max === 'number') {
    constrainedValue = Math.min(constrainedValue, max);
  }
  return constrainedValue;
}

function constrain(value, config) {
  if (!config) {
    return value;
  }
  if (config.bounce === true) {
    return constrainBounce(value, config.min, config.max);
  }
  return constrainHard(value, config.min, config.max);
}

function constrainHardOnly(value, config) {
  if (!config || config.bounce === true) {
    return value;
  }
  return constrainHard(value, config.min, config.max);
}


//////////////////
// WEBPACK FOOTER
// ./~/buttery/lib/DragConfig.js
// module id = 74
// module chunks = 0